import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const PageTitleContainer = styled.div`
  margin-top: ${tokens.space.larger};
`;

export const Content = styled.div`
  margin-top: ${tokens.space.large};
  margin-bottom: 0;
  font-family: ${tokens.font.family.ifood.body};
`;
